/*
 * Similar Collections - for collection pages
 *
 **/
require('custom/collection-card');
require('custom/gtm-handler'); // Google Tag Manager Handler
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { USER_UNAUTH_COLLAB, DEFAULT_ATTR_TO_RETRIEVE } from '../common/constant';

custom.similarCollections = (() => {

  /**
   * Similar Collection Search by Algolia
   * @params options - An options object
   * @requires options.id - Algolia Search Account ID
   * @requires options.key - Algolia Search Key
   * @requires options.searchIndex - Instant Search Index
   */
  const init = (item = {}, options = {}) => {

    // Presets
    const defaults = {
      id: algoliaShopify.config.app_id, // Account ID
      key: algoliaShopify.config.search_api_key, // Account Key
      searchIndex: window.AlgoliaIndices.collections, // InstantSearch Index
      productSearchIndex: window.AlgoliaIndices.products, // InstantSearch Index
      searchLimit: 4, // Hits per page
      instantSearchFilter: '', // Type to filter (ie. Rugs, Latest, etc)
      resultsWrapperClass: "js-similar-collections",
      resultsContainerID: 'similar-collections', // Results ID
      attributesToRetrieve: null,
      cardRenderedCallback: null, // Do something with UI after rendering
      resultsLoadedCallback: null, // Do something after payload is added to DOM
    };

    // Merge args
    const opts = Object.assign({}, defaults, options);

    // Test for Algolia Account ID (required)
    try {
      if (!opts.id) {
        throw 'Please provide an Algolia Account ID (options.id)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for Algolia Account Key (required)
    try {
      if (!opts.key) {
        throw 'Please provide an Algolia Account Key (options.key)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Test for instantSearchIndex (required)
    try {
      if (!opts.searchIndex) {
        throw 'Please provide an Algolia Search Index (options.instantSearchIndex)';
      }
    } catch (e) {
      console.log('error: ', e);
      return;
    }

    // Attributes needed to render
    if (!opts.attributesToRetrieve) opts.attributesToRetrieve = DEFAULT_ATTR_TO_RETRIEVE;

    // ---------- Filter & Filter Facets Query
    let filters = `NOT handle:${item.handle} AND meta.loloi.product_type:${item.product_type}`;
    let facetFilters = [];
    let numericFilters = [];
    let optionalFilters = [];

    // 01. Price - Price Range
    if (item.price && item.price != "" && item.price != "F") {
      const range = custom.utils.getPriceRange(item.price).split(":");
      numericFilters.push(`meta.loloi.price>=${range[0]}`);
      numericFilters.push(`meta.loloi.price<=${range[1]}`);
    }
    // 02. Material
    if (item.material && item.material != "" && item.material != "F") {
      facetFilters.push(`meta.loloi.material_filter:${item.material}`);
    }
    // 03. Construction
    if (item.construction && item.construction != "" && item.construction != "F") {
      facetFilters.push(`meta.loloi.construction:${item.construction}`);
    }
    // 04. Collection (exclude)
    // if (item.collection && item.collection != "") {
    //   facetFilters.push(`named_tags.Collection:-${item.collection}`);
    // }
    // 05. Collaboration
    if (item.collaboration && item.collaboration != "" && item.collaboration != "F") {
      optionalFilters.push(`meta.loloi.collaboration:${item.collaboration}`);
    }
    // 05. Collaboration (exclude)
    if (USER_UNAUTH_COLLAB) {
      USER_UNAUTH_COLLAB.forEach(function (collaboration, index) {
        facetFilters.push(`meta.loloi.collaboration:-${collaboration}`);
      });
    }
    // 06. Style
    if (item.style && item.style != "" && item.style != "F") {
      facetFilters.push(`meta.loloi.style:${item.style}`);
    }
    // 07. Hide collections with no products
    numericFilters.push(`meta.loloi.product_count>0`);

    // Initialize search client
    if (opts.searchIndex) {
      opts.searchClient = algoliasearch(opts.id, opts.key);
    }


    function renderCallback() {
      // custom.collectionCard.init(collectionHandle);
      // insertNumOfTheRest(collectionHandle, moreNum);
      custom.typeDesignId.init();
      custom.gtmHandler.init();
      custom.lazyImages.init();
    }

    /**
     * getSimilarCollections
     * @params options - An options object
     *
     * Call algolia search API, returns Promise object
     */
    const getSimilarCollections = (item) => {
      if (!opts.searchIndex) return;

      // Checks for curated list of collections thats set in the Shopify Collections custom fields
      if (item.similar_collections.length > 0) {
        var curatedFilters = '';

        item.similar_collections.forEach(function(collection, index) {
          curatedFilters += index == item.similar_collections.length - 1 ? ` handle:"${collection.handle}"` : ` handle:"${collection.handle}" OR`;
        });

        numericFilters = [];
        facetFilters = [];
        optionalFilters = [];
      }

      return opts.searchClient.search({
        requests: [
          {
            indexName: opts.searchIndex,
            query: '',
            hitsPerPage: opts.searchLimit,
            distinct: true,
            attributesToRetrieve: opts.attributesToRetrieve,
            filters: curatedFilters ? curatedFilters : filters,
            numericFilters: numericFilters,
            facetFilters: facetFilters,
            optionalFilters: optionalFilters,
          },
        ],
      })
      // Return hits result
      .then(res => res.results[0].hits)
      // Promise could not resolve
      .catch(err => console.log('collections search error: ', err));
    };


    /**
     * renderCollections
     * @params hits - algolia results object
     *
     * Render each result after object manipuration,
     * Hide if no result from Algolia.
     */
    const renderCollections = hits => {
      if (hits && hits.length > 0) {
        // Loop through each hit
        hits.forEach((hit, i, array) => {
          // Collection Image Mapper, Reducer
          if (hit['meta']['loloi']['products_json']) {
            var products = JSON.parse(custom.utils.unescapeUtil(hit['meta']['loloi']['products_json']));
            hit = custom.algoliaUtils.collectionImageMapper(hit, products);
          } else {
            hit = custom.algoliaUtils.collectionImageMapper(hit);
          }
          array[i] = custom.algoliaUtils.resultObjectReducer(hit);

          hit.lazyload = true;

          // Render
          document.getElementById(opts.resultsContainerID).insertAdjacentHTML('beforeend', window.collectionCardTemplate.render(array[i]));
          window.pubsub.trigger("hasRenderedCollectionCard", hit.handle);
        });
        renderCallback();
      } else {
        //no matches found hide this section
        document.getElementsByClassName(opts.resultsWrapperClass)[0].classList.add("hidden");
      }
    }

    getSimilarCollections(item).then(res => {
      return renderCollections(res);
    });
  }
  return {
    init
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/similar-collections.js